export default "__VITE_ASSET__D5om37s7__"